import {
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import MaterialTable from 'src/components/SelectMaterial/materialControl';
import { checkHizmet } from 'src/utils/storage/Defect';
import { checkIscilik } from 'src/utils/storage/Labour';
import { checkMalzeme } from 'src/utils/storage/Material';
import {
  loadUrunControlDetail,
  saveUrunControlDetail
} from 'src/utils/storage/StartWorkOrder';
import {
  getDefectRequest,
  getLabourRequest,
  getMaterialRequest
} from '../../store/actions';
import { addDefects, resetDefects } from '../../store/actions/defectActions';
import { addLabours, resetLabours } from '../../store/actions/labourActions';
import {
  addMaterials,
  resetMaterials
} from '../../store/actions/materialActions';

const useStyles = makeStyles(theme => ({
  root: {}
}));

function Hizmet({
  resetDefects,
  resetLabours,
  resetMaterials,
  defectReducer,
  labourReducer,
  materialReducer,
  getDefectRequest,
  getLabourRequest,
  getMaterialRequest,
  addDefects,
  addLabours,
  addMaterials
}) {
  const classes = useStyles();
  const { t } = useTranslation('product_detail_control');
  const [open, setOpen] = React.useState(false);
  const [Uyari, setUyari] = React.useState('');
  const HizmetData = loadUrunControlDetail();

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (loadUrunControlDetail().length === 0) {
      return;
    }

    const kulmodelkodu = loadUrunControlDetail()[0].KUL_MODEL_KODU;
    const uyil = loadUrunControlDetail()[0].UYIL || 0;
    const udonem = loadUrunControlDetail()[0].UDONEM || 0;
    const WorkOrderIdParam = loadUrunControlDetail()[0].ReceiptNo || 0;

    if (defectReducer.Data.length === 0) {
      resetDefects();
      getDefectRequest(kulmodelkodu, 1, '');
    }
    if (materialReducer.Data.length === 0) {
      resetMaterials();
      getMaterialRequest(kulmodelkodu, 1, 1, uyil, udonem,WorkOrderIdParam);
    }
    if (labourReducer.Data === 0) {
      resetLabours();
      getLabourRequest(kulmodelkodu, 1, 1, '',WorkOrderIdParam);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (loadUrunControlDetail().length === 0) {
      return;
    }
    const kulmodelkodu = loadUrunControlDetail()[0].KUL_MODEL_KODU;
    const uyil = loadUrunControlDetail()[0].UYIL;
    const udonem = loadUrunControlDetail()[0].UDONEM;
    const WorkOrderIdParam = loadUrunControlDetail()[0].ReceiptNo || 0;
    
    if (!checkHizmet(kulmodelkodu)) {
      resetDefects();
      getDefectRequest(kulmodelkodu, 1, '');
    }
    if (!checkMalzeme(kulmodelkodu)) {
      resetMaterials();
      getMaterialRequest(kulmodelkodu, 1, 1, uyil, udonem,WorkOrderIdParam);
    }
    if (!checkIscilik(kulmodelkodu)) {
      resetLabours();
      getLabourRequest(kulmodelkodu, 1, 1, '',WorkOrderIdParam);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (loadUrunControlDetail().length === 0) {
      return;
    }
    const merkez = loadUrunControlDetail();

    setUyari(t('hizmet_reload_message'));
    setOpen(true);
    resetDefects();
    resetMaterials();
    resetLabours();
    getDefectRequest(merkez[0].KUL_MODEL_KODU, 1, '');
    getMaterialRequest(
      merkez[0].KUL_MODEL_KODU,
      1,
      1,
      merkez[0].UYIL || 0,
      merkez[0].UDONEM || 0
    );
    const curr = merkez[0];
    getLabourRequest(merkez[0].KUL_MODEL_KODU, 1, 1, '',merkez.ReceiptNo);
    if (curr.HIZMETLER) {
      const selectedDefects = [];
      let laboursHizmet = {};
      let materialsHizmet = {};
      curr.HIZMETLER.forEach(function(h, index) {
        selectedDefects.push(h.HIZMET_KODU);
        laboursHizmet = { ...laboursHizmet, [h.HIZMET_KODU]: [] };
        materialsHizmet = { ...materialsHizmet, [h.HIZMET_KODU]: [] };
      });
      addDefects(selectedDefects);
      if (curr.ISCILIKLER) {
        curr.ISCILIKLER.forEach(function(i, index) {
          laboursHizmet[i.HIZMET_KODU].push(i.KUL_ISCILIK_KODU.toString());
        });
        addLabours(laboursHizmet);
      }
      if (curr.MALZEMELER) {
        curr.MALZEMELER.forEach(function(i, index) {
          materialsHizmet[i.HIZMET_KODU].push(i.MALZEME_STOK_NO.toString());
          materialsHizmet = { ...materialsHizmet, [i.MALZEME_STOK_NO]: i.ADET };
        });
        addMaterials(materialsHizmet);
      }
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!loading) {
      localStorageKaydet();
    }
    // eslint-disable-next-line
  }, [defectReducer, materialReducer, labourReducer]);

  const localStorageKaydet = () => {
    if (defectReducer.Data.length === 0) {
      return;
    }
    let job = loadUrunControlDetail()[0];
    const hizmetlerH = [];
    const isciliklerH = [];
    const malzemelerH = [];
    let iscilik_toplam = 0;
    let malzeme_toplam = 0;
    for (let h = 0; h < defectReducer.selected.length; h++) {
      const hizmet = defectReducer.selected[h];
      const hizmetRedux = defectReducer.defectsTable[hizmet];
      hizmetlerH.push({
        HIZMET_KODU: hizmet,
        KUL_HIZMET_KODU: hizmetRedux?.UserCode,
        ACIKLAMA: hizmetRedux?.DefectDesc,
        TIP: hizmetRedux?.DefectType,
        TIP_KODU: hizmetRedux?.DefectTypeCode
      });
      const labourArray = labourReducer[hizmet];
      if (labourArray && labourArray.length > 0) {
        for (let i = 0; i < labourArray.length; i++) {
          const iscilik = labourReducer.Data.filter(
            d => d.LabourCode === labourArray[i]
          )[0];
          if (iscilik) {
            isciliklerH.push({
              ISCILIK_KODU: iscilik.LabourId,
              HIZMET_KODU: hizmet,
              KUL_ISCILIK_KODU: iscilik.LabourCode,
              ACIKLAMA: iscilik.LabourDesc,
              FIYAT:
                parseInt(job.GARANTI_TIPI) === 1
                  ? iscilik.PriceWithoutWarranty
                  : iscilik.Price,
              FIYAT_LISTESI_ID:
                parseInt(job.GARANTI_TIPI) === 1
                  ? iscilik.PriceListIdWithoutWarranty
                  : iscilik.PriceListId,
              FIYAT_KODU: iscilik.PriceId
            });
            iscilik_toplam +=
              parseInt(job.GARANTI_TIPI) === 1
                ? iscilik.PriceWithoutWarranty
                : iscilik.Price;
          }
        }
      }
      const materialArray = materialReducer[hizmet];
      if (materialArray && materialArray.length > 0) {
        for (let m = 0; m < materialArray.length; m++) {
          const malzeme = materialReducer.Data.filter(
            d => d.MaterialCode === materialArray[m]
          )[0];
          if (malzeme) {
            malzemelerH.push({
              MALZEME_KODU: malzeme.MaterialId,
              HIZMET_KODU: hizmet,
              MALZEME_STOK_NO: malzeme.MaterialCode,
              ADET: materialReducer[malzeme.MaterialCode],
              ACIKLAMA: malzeme.MaterialDesc,
              FIYAT: malzeme.PriceWithWat,
              FIYAT_LISTESI_ID: malzeme.PriceListId,
              FIYAT_KODU: malzeme.PriceId
            });
            malzeme_toplam +=
              materialReducer[malzeme.MaterialCode] * malzeme.PriceWithWat;
          }
        }
      }
    }
    job = {
      ...job,
      HIZMETLER: hizmetlerH,
      ISCILIKLER: isciliklerH,
      MALZEMELER: malzemelerH,
      ISCILIK_TOPLAM: iscilik_toplam,
      MALZEME_TOPLAM: malzeme_toplam
    };
    saveUrunControlDetail(job);
  };

  if (
    HizmetData === undefined ||
    HizmetData === '' ||
    HizmetData === null ||
    HizmetData.length === 0
  ) {
    return (
      <Card>
        <CardHeader title={t('Urun_Kontrolu')} />
        <Divider />
        <CardContent>{t('Urun_Kontrol_Mesaji')}</CardContent>
      </Card>
    );
  }

  if (
    HizmetData[0].KUL_MODEL_KODU === undefined ||
    HizmetData[0].KUL_MODEL_KODU === '' ||
    HizmetData[0].KUL_MODEL_KODU === null
  ) {
    return (
      <Card>
        <CardHeader title={t('Urun_Kontrolu')} />
        <Divider />
        <CardContent>{t('Urun_Kontrol_Mesaji')}</CardContent>
      </Card>
    );
  }

  const loading =
    defectReducer.loading || materialReducer.loading || labourReducer.loading;

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">
          Bilgilendirme
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {Uyari}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            {t('Tamam')}
          </Button>
        </DialogActions>
      </Dialog>
      {defectReducer.error.length > 0 && (
        <Typography>
          Hizmet Hata:
          {defectReducer.error}
        </Typography>
      )}
      {labourReducer.error.length > 0 && (
        <Typography>
          İşçilik Hata:
          {labourReducer.error}
        </Typography>
      )}
      {materialReducer.error.length > 0 && (
        <Typography>
          Hizmet Hata:
          {materialReducer.error}
        </Typography>
      )}
      {loading ? (
        <CircularProgress status="loading" style={{ marginLeft: '50%' }} />
      ) : defectReducer.Data.length === 0 && !window.navigator.onLine ? (
        <Card>
          <CardHeader title={t('Offline_Data_Kontrolu')} />
          <Divider />
          <CardContent className={classes.contentH}>
            {t('Offline_Data_Kontrol_Mesaji')}
          </CardContent>
        </Card>
      ) : (
        <MaterialTable defect={0} GosterimAdet={30} />
      )}
    </div>
  );
}

Hizmet.propTypes = {
  className: PropTypes.string
};

export default connect(
  state => ({
    tasks: state.tasks1,
    defectReducer: state.defectReducer,
    labourReducer: state.labourReducer,
    materialReducer: state.materialReducer,
    resetDefects: state.resetDefects,
    resetLabours: state.resetLabours,
    resetMaterials: state.resetMaterials
  }),
  {
    resetDefects,
    resetLabours,
    resetMaterials,
    getDefectRequest,
    getLabourRequest,
    getMaterialRequest,
    addDefects,
    addLabours,
    addMaterials
  }
)(Hizmet);
